export interface IPopUps {
  [key: string]: boolean | number;
}

export class PopUps {
  showAquamanPerformanceRunPopup = false;
  showAttractScreenPopup = false;
  showBluthPerformanceRunPopup = false;
  showCalendarFeaturePopup = false;
  showEntertainmentPopup = false;
  showHaloAnnouncementPopup = false;
  showHaloUpgradePopup = false;
  showHalomediaPopup = false;
  showIdlePopStats = false;
  showNavigationPopup = false;
  showNewHomeDashPopup = false;
  showOnDemandClassesPopup = false;
  showReleaseCenterPopup = false;
  showServiceNoticesFeaturePopup = false;
  showSupermanPerformanceRunPopup = false;
  showSurveyPopup = false;
  showHealthSafetyPopup = false;
  showMicrositePopup = false;
  showSubscriptionPopup = false;
  showOnboardingPopup = false;
  showMultisitePopup = false;
  showLFODPremiumTooltip = false;
  showDigitalCoachPopup = false;
  showDigitalCoachAnnouncementPopup = false;
  showDigitalCoachDashboardBanner = false;
  showNewPermissionTooltip = false;
  showCustomLibraryPopup = false;
  showServiceRequestsTrackStatusTooltip = false;
  showCreateJobOrderTooltip = false;
  showProductWarrantyTooltip = false;
  showServiceTicketsActivityTooltip = false;
  showErrorCodesTooltip = false;
  fcAnnouncementBanner = false;
  // for type validation
  [key: string]: boolean;
}

export interface IFacilityUserSummary {
  facility: FacilitySummaryObject;
  user: FacilityMaintainanceUserDetailsObject | null;
}
export class FacilitiesResponse {
  hasOptedInFacility: string;
  hasProEnabledFacility: string;
  isAdminAnyFacility: string;
  isOwnerAnyFacility: string;
  lastSelectedConsole: string;
  lastSelectedFacility: string;
  lastSelectedFacilityList: string[];
  showAquamanPerformanceRunPopup: string;
  showAttractScreenPopup: string;
  showBluthPerformanceRunPopup: string;
  showCalendarFeaturePopup: string;
  showEntertainmentPopup: string;
  showHaloAnnouncementPopup: string;
  showHaloUpgradePopup: string;
  showHalomediaPopup: string;
  showIdlePopStats: string;
  showNavigationPopup: string;
  showNewHomeDashPopup: string;
  showOnDemandClassesPopup: string;
  showReleaseCenterPopup: string;
  showServiceNoticesFeaturePopup: string;
  showSupermanPerformanceRunPopup: string;
  showSurveyPopup: string;
  facilities: FacilityObject[];
  showHealthSafetyPopup: string;
  showMicrositePopup: string;
  showSubscriptionPopup: string;
  showOnboardingPopup: string;
  showMultisitePopup: string;
  manageFacilityHint: string;
  hasCmsLegalReconsent: string;
  fcAnnouncementBanner: string;
  // for type validation
  [key: string]: any;
}

export class FacilityObject {
  facilityId: string;
  facilityName: string;
  summary: FacilitySummaryObject;
  consoleEquipments: FacilityConsoleEquipmentsObject[];
  ipAddress: string;
  hasCmsLegalReconsent: string;
}

export class FacilitySummaryObject {
  facilityName: string;
  facilityId: string;
  facilityAddress: string;
  phoneNumber: string;
  timezone: string;
  timezoneName: string;
  facilityType: string;
  countryId: string;
  countryIsoCode: string;
  address: string;
  state: string;
  city: string;
  addressStatus: string;
  postalCode: string;
  isConnected: string;
  hasUnnamedEquip: string;
  noOfManagers: string;
  soleManager: string;
  hasUnnamedNewEquip: string;
  isHeatMapAssetsAdded: string;
  isLoggedInManagerAdmin: string;
  hasDisplayNameForEquip: string;
  isPlanetFitness: string;
  facilityHours: string;
  offset: string;
  facilityHoursStart: string;
  facilityMinsStart: string;
  facilityHoursEnd: string;
  facilityMinsEnd: string;
  statEmail: string;
  releaseNotesEmail: string;
  isOptedIn: string;
  isProEnabled: string;
  canUpgradeHalo: string;
  purchasedPlans: string;
  userRights: FacilitySummaryUserRightsObject;
  facilityRights: FacilitySummaryFacilityRightsObject;
  staffPermissionData: FacilitySummaryStaffPermissionDataObject;
  hasLFODEnabledSetup: string;
  countryName?: string;
  hasHealthSafetySetup: string;
  mixedOnboardingFacility: string;
  outdatedOnboardingAssetCount: number;
  isSubscriptionBannerEnabled: string;
  hasSubscriptionSetup: string;
  isLFODSupportedFacility: boolean;
  isSelected: boolean;
  //halo pro countries related variables
  isDigitalCoachEligible: string;
  isSubscriptionsEligible: string;

  herculesTread: number;
  batmanTread: number;
  robinTread: number;
  mylesTread: number;
}

export class FacilitySummaryUserRightsObject {
  branding: string;
  calendar: string;
  coreRequested: string;
  customAppRequested: string;
  customize: string;
  engageSubscribed: string;
  facility: string;
  facilityId: string;
  facilityStaff: string;
  jobTrackerRequested: string;
  membersChallenges: string;
  membersManage: string;
  membersPromote: string;
  membersRetention: string;
  optedIn: string;
  proSubscribed: string;
  retentionRequested: string;
  serviceNotice: string;
  software: string;
  stats: string;
  trainRequested: string;
  trainingChallenges: string;
  trainingClasses: string;
  trainingPrograms: string;
  userId: string;
  disconnectNotification: string;
  lfodEnabledEquipment: string;
  digitalCoach: string;
  isAdmin: string;
  customLibrary: string;
}

export class FacilitySummaryFacilityRightsObject {
  announcement: string;
  attractScreen: string;
  branding: string;
  calendar: string;
  customWorkouts: string;
  customize: string;
  digitalCoach: string;
  entertainment: string;
  facility: string;
  facilityStaff: string;
  home: string;
  isPlanetFitness: string;
  jobTracker: string;
  lfodEnabledEquipment: string;
  healthSafety: string;
  lifescapeCourse: string;
  managerType: string;
  membersChallenges: string;
  membersManage: string;
  membersMenu: string;
  membersPromote: string;
  membersRetention: string;
  videoLibrary: string;
  customLibrary: string;
  micrositeWidget: string;
  performanceRun: string;
  productSetting: string;
  remoteSoftware: string;
  rideSocial: string;
  serviceNotice: string;
  serviceNoticeMaint: string;
  software: string;
  stats: string;
  trainingChallenges: string;
  trainingClasses: string;
  trainingMenu: string;
  trainingPrograms: string;
}

export class FacilitySummaryStaffPermissionDataObject {
  branding: string;
  brandingEnabled: string;
  brandingOptedIn: string;
  calendarEnabled: string;
  coreOptedIn: string;
  customAppEnabled: string;
  customAppOptedIn: string;
  customizeEnabled: string;
  engageOptedIn: string;
  equipmentSettingsEnabled: string;
  facility: string;
  facilityEnabled: string;
  facilityStaff: string;
  facilityStaffEnabled: string;
  haloMediaOptedIn: string;
  jobTrackerEnabled: string;
  jobTrackerOptedIn: string;
  maintenanceEnabled: string;
  membersChallenges: string;
  membersChallengesEnabled: string;
  membersChallengesOptedIn: string;
  membersEnabled: string;
  membersManage: string;
  membersManageEnabled: string;
  membersManageOptedIn: string;
  membersPromote: string;
  membersPromoteEnabled: string;
  membersPromoteOptedIn: string;
  membersRetention: string;
  membersRetentionEnabled: string;
  membersRetentionOptedIn: string;
  performanceRunHaloEnabled: string;
  performanceRunOptedIn: string;
  proOptedIn: string;
  serviceNotice: string;
  serviceNoticeEnabled: string;
  softwareEnabled: string;
  statsEnabled: string;
  trainOptedIn: string;
  trainingChallenges: string;
  trainingChallengesEnabled: string;
  trainingChallengesOptedIn: string;
  trainingClasses: string;
  trainingClassesEnabled: string;
  trainingClassesOptedIn: string;
  trainingEnabled: string;
  trainingPrograms: string;
  trainingProgramsEnabled: string;
  trainingProgramsOptedIn: string;
}

export class FacilityConsoleEquipmentsObject {
  [x: string]: number | string | object | undefined;
  consoleType: string;
  consoleId: string;
  equipments: ConsoleEquipmentsListObject[];
  pendingCount?: number;
}

export class ConsoleEquipmentsListObject {
  activityId: string;
  count: string;
  equipmentOrderId: string;
}

export class FacilityMaintainanceUserDetailsObject {
  email: string;
  nickname: string;
  password: string;
  preferredLanguage: string;
  emailNotificationsOK: boolean;
  fbUserId: string;
  fbAccessToken: string;
  linkToUser: boolean;
  twitterUserId: string;
  twitterAccessCode: string;
  twitterCodeSecret: string;
  firstName: string;
  lastName: string;
  optinResearch: boolean;
}

/**
 * RFID Members
 */
export interface SaveMembers {
  memberList: any;
  customEmail?: string;
  preferredLanguage: string;
  preferredUnit: string;
  emailSalutation: string;
  emailContent1: string;
  emailContent2: string;
  emailContent3: string;
  emailContent4: string;
  emailContent5: string;
  facilityId: string;
}
export interface RFIDMemberResponse {
  members: RFIDMember[];
  nonSharedMembersCount: string;
  sharedMembersCount: string;
  totalMembersCount: string;
}

export class RFIDMember {
  email: string;
  firstName: string;
  gender: string;
  lastName: string;
  userId: string;
  rfId?: string;
  rfid?: string;
  isDuplicateRfid?: string;
  isEmailError?: string;
  isGenderError?: string;
  isRfidError?: string;
  // action only (NOTE FROM DB)
  isEditFormOpen?: boolean;
  isSelected?: boolean;
}

export class UpdateRFIDMember {
  email: string;
  firstName: string;
  gender: string;
  lastName: string;
  userId: string;
  rfId?: string;
}

export class DelinkRFIDMember {
  email: string;
  userId: string;
  rfId?: string;
}

export class IHeatMapDash {
  facilityProgress: string;
  isDataCollected: string;
  isFirstTimeClickedManager: string;
  isHeatMapAssetsAdded: string;
  isNewEquipment: string;
  isPendingEquipment: string;
  isSetupEquipmentsClicked: string;
  isSetupFacilityDashClicked: string;
  isSetupManagersClicked: string;
  newEquipmentCount: string;
}

export class MultipleFacilityPublish {
  onDemandClassesUpdateWrapper: MultipleFacilityPublishItem[];
}

export class MultipleFacilityPublishItem {
  facilityId: string | undefined;
  consoleType: string;
  assetIds: string[];
  lfodEnabledStatus?: boolean;
  lifescapeEnabledStatus?: boolean;
  customLibraryEnabledStatus?: boolean;
  managerId: number;
}
